import { NavLink } from 'react-router-dom'
import { NAV_ITEMS } from '../navItems'
import { useProfile, dayNumberFromStartDate, useAiPlan } from '../lib/hooks'
import { getEffectiveDayPlan, TOTAL_DAYS } from '../data/plan'

export default function Sidebar() {
  const { profile } = useProfile()
  const { aiPlan } = useAiPlan()
  const dayNumber = profile?.startDate ? dayNumberFromStartDate(profile.startDate) : 1
  const plan = getEffectiveDayPlan(dayNumber, aiPlan)
  const pct = Math.max((dayNumber / TOTAL_DAYS) * 100, 1.1)

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        <img src="/health-icons/icon-512.png" alt="" className="brand-mark" />
        <div>
          <div className="brand-name">HEALTHNEST</div>
          <div className="brand-sub">CUT PROGRAM</div>
        </div>
      </div>
      <nav className="sidebar-nav">
        {NAV_ITEMS.map(({ to, num, label }) => (
          <NavLink key={to} to={to} className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`}>
            <span className="sidebar-nav-num">{num}</span>
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="sidebar-progress">
        <div className="sidebar-progress-top">
          <span>PROGRAM</span>
          <span style={{ color: 'var(--h-accent)' }}>DAY {String(dayNumber).padStart(2, '0')}/{TOTAL_DAYS}</span>
        </div>
        <div className="sidebar-progress-bar">
          <div className="sidebar-progress-fill" style={{ width: `${pct}%` }} />
        </div>
        <div className="muted small">Phase {plan.phase.id} · Week {plan.week}</div>
      </div>
    </aside>
  )
}
